const OOBE_TASKS_UPDATE = 'OOBE_TASKS_UPDATE'
const OPEN_WHAT_CAN_I_SAY_MODAL = 'OPEN_WHAT_CAN_I_SAY_MODAL'
const OPEN_SETTINGS_MODAL = 'OPEN_SETTINGS_MODAL'
const OPEN_NOTE_TYPE_MODAL = 'OPEN_NOTE_TYPE_MODAL'
const OOBE_LAYOUT_UPDATE = 'OOBE_LAYOUT_UPDATE'
const EMR_INTEGRATION_DETAILS_UPDATE = 'EMR_INTEGRATION_DETAILS_UPDATE'
const OPEN_SCHEDULE = 'OPEN_SCHEDULE'
const OPEN_LIST = 'OPEN_LIST'
const CLOSE_MODAL = 'CLOSE_MODAL'
export {
  OOBE_TASKS_UPDATE,
  OPEN_WHAT_CAN_I_SAY_MODAL,
  OPEN_SETTINGS_MODAL,
  OPEN_NOTE_TYPE_MODAL,
  OOBE_LAYOUT_UPDATE,
  EMR_INTEGRATION_DETAILS_UPDATE,
  OPEN_SCHEDULE,
  OPEN_LIST,
  CLOSE_MODAL
}
